import httpService from "./httpService";
import utils from "./utils";

const hanhchinhService = {
  getProcedureInformation(flowCode) {
    let params = utils.merge({flowCode: flowCode});
    return httpService.get("/hanhchinh/getFlowInfo", {params: params});
  },

  getFlowsCanStart(flowCode) {
    let params = utils.merge({flowCode: flowCode});
    return httpService.get("/hanhchinh/getFlowsCanStart", {params: params});
  },

  getFlowsAvailable(flowCode) {
    let params = utils.merge({flowCode: flowCode});
    return httpService.get("/hanhchinh/getFlowsAvailable", {params: params});
  },

  RegisterMeetingRoom(form) {
    return httpService.post("/phonghop/create", form);
  },

  RegisterMeetingRoomUnexpected(form) {
    return httpService.post("/phonghop/createDx", form);
  },

  dangKiDieuXeDotXuat(form) {
    return httpService.post("/dieuxe/createDx", form);
  },

  getListMeetingRoomFree(startTime, endTime, flowCode) {
    let params = utils.merge(
      utils.merge({
        startTime: startTime,
        endTime: endTime,
        flowCode: flowCode
      })
    );
    return httpService.get("/phonghop/roomfree", {params: params});
  },

  getListCarIsEmptys(startTime, endTime, flowCode) {
    let params = utils.merge(
      utils.merge({
        startTime: startTime,
        endTime: endTime,
        flowCode: flowCode
      })
    );
    return httpService.get("/dieuxe/carfree", {params: params});
  },

  getListDriverFree(flowCode) {
    let params = utils.merge(utils.merge({flowCode: flowCode}));
    return httpService.get("/dieuxe/listDriver", {params: params});
  },

  getListCar(flowCode) {
    let params = utils.merge(utils.merge({flowCode: flowCode}));
    return httpService.get("/dieuxe/listCar", {params: params});
  },

  MeetingRoomDetail(caseMasterId) {
    return httpService.get(`phonghop/detail/${caseMasterId}`);
  },

  getProcessing(flowCode, startTime, endTime, searchKey, pageable) {
    let params = utils.merge(
      utils.merge({
        flowCode: flowCode,
        startTime: startTime,
        endTime: endTime,
        key: searchKey
      }),
      pageable
    );

    return httpService.get("/hanhchinh/filterProcessingRequest", {
      params: params
    });
  },

  getProcessed(flowCode, startTime, endTime, searchKey, pageable) {
    let params = utils.merge(
      utils.merge({
        flowCode: flowCode,
        startTime: startTime,
        endTime: endTime,
        key: searchKey
      }),
      pageable
    );

    return httpService.get("/hanhchinh/filterProcessedRequest", {
      params: params
    });
  },

  getAction(caseMasterId) {
    let params = utils.merge({
      caseMasterId: caseMasterId
    });
    return httpService.get("/hanhchinh/getAvailableActions", {
      params: params
    });
  },

  getStatus(caseMasterId) {
    let params = utils.merge({
      caseMasterId: caseMasterId
    });
    return httpService.get("/hanhchinh/getCurrentState", {
      params: params
    });
  },

  approve(form) {
    return httpService.post("/phonghop/approve", form);
  },

  cancel(form) {
    return httpService.post("/phonghop/cancel", form);
  },

  updateRoom(form) {
    return httpService.post("/phonghop/update", form);
  },

  registerCarRequest(form) {
    return httpService.post("/dieuxe/create", form);
  },

  carRequestDetail(caseMasterId) {
    return httpService.get(`/dieuxe/detail/${caseMasterId}`);
  },

  approveCarRequest(form) {
    return httpService.post("/dieuxe/approve", form);
  },

  updateCar(form) {
    return httpService.post("/dieuxe/update", form);
  },

  cancelCar(form) {
    return httpService.post("/dieuxe/cancel", form);
  },

  getRegisRoomCalendar(startTime, endTime, flowCode) {
    let params = utils.merge(
      utils.merge({
        startTime: startTime,
        endTime: endTime,
        flowCode: flowCode
      })
    );
    return httpService.get("/phonghop/calendarRoom", {params: params});
  },

  getCarCalendar(startTime, endTime, flowCode) {
    let params = utils.merge(
      utils.merge({
        startTime: startTime,
        endTime: endTime,
        flowCode: flowCode
      })
    );
    return httpService.get("/dieuxe/calendarCar", {params: params});
  },

  getDirective(parentDeptId) {
    return httpService.get(`/chidao/getListLDDV?deptId=${parentDeptId}`);
  },

  getDept(parentDeptId) {
    return httpService.get(`/chidao/getListDVTT?deptId=${parentDeptId}`);
  },

  getStaff(deptId) {
    return httpService.get(`/chidao/getListCVDV?deptId=${deptId}`);
  },

  getCommandDetail(caseMasterId) {
    let params = utils.merge({
      caseMasterId: caseMasterId
    });
    return httpService.get("/chidao/detail", {
      params: params
    });
  },

  updateCommand(form) {
    return httpService.post("/chidao/update", form);
  },

  cancelCommand(form) {
    return httpService.post("/chidao/cancel", form);
  },
  dangKyLichTuan(form) {
    return httpService.post("/lichtuan/create", form);
  },
  getListDVPH(deptId) {
    let params = utils.merge({deptId: deptId});
    return httpService.get(`/lichtuan/getListDVPH`, {params: params});
  },
  getListLDLichTuan(deptId) {
    let params = utils.merge({deptId: deptId});
    return httpService.get(`/lichtuan/getListLDLichTuan`, {params: params});
  },
  getListRoomFree(startTime, endTime) {
    return httpService.get(
      `/lichtuan/getListRoomFree?startTime=${startTime}&endTime=${endTime}`
    );
  },
  getSentRequests(startDate, endDate, keyword, pageable, approveStatus) {
    return httpService.get(`/lichtuan/getSentRequests?startDate=${startDate}&endDate=${endDate}
    &size=${pageable.size}&page=${pageable.page}&sort=${
      pageable.sort
      }&keyword=${keyword}&approveStatus=${approveStatus}`);
  },
  getNeedProcessRequests(startDate, endDate, keyword, pageable, approveStatus) {
    return httpService.get(`/lichtuan/getNeedProcessRequests?startDate=${startDate}&endDate=${endDate}
    &size=${pageable.size}&page=${pageable.page}&sort=${
      pageable.sort
      }&keyword=${keyword}&approveStatus=${approveStatus}`);
  },

  getAcceptedRequests(startDate, endDate, keyword, pageable) {
    return httpService.get(`/lichtuan/getAcceptedRequests?startDate=${startDate}&endDate=${endDate}
    &size=${pageable.size}&page=${pageable.page}&sort=${
      pageable.sort
      }&keyword=${keyword}`);
  },

  getAcceptedRequestsIncludeCoopDepts(
    startDate,
    endDate,
    keyword,
    deptId,
    pageable,
    approveStatus
  ) {
    let params = utils.merge(
      utils.merge({
        startDate: startDate,
        endDate: endDate,
        keyword: keyword,
        deptId: deptId,
        includeShared: true,
        approveStatus
      }),
      pageable
    );
    return httpService.get(`/lichtuan/getAcceptedRequestsIncludeCoopDepts`, {
      params: params
    });
  },

  //chi tiet lich tuan
  getRegiscalendarweekDetail(caseMasterId) {
    return httpService.get(`/lichtuan/detail/${caseMasterId}`);
  },

  // cap nhat yc lich tuan
  updateCalendarWeek(form) {
    return httpService.post("/lichtuan/update", form);
  },

  // huy yc lich tuan
  cancelCalendarWeek(form) {
    return httpService.post("/lichtuan/cancel", form);
  },

  // phe duyet/ tu choi yc lich tuan
  approveCalendarWeek(form) {
    return httpService.post("/lichtuan/approve", form);
  },
  //thay doi trang thai cua l?ch tuan
  changeCalendarStatus(form) {
    return httpService.post("/lichtuan/changestatus", form);
  },

  // gui tong hop thong bao
  sentGeneralNotify(form) {
    return httpService.post("/lichtuan/sendNotify", form);
  },

  checkMissingFlow(flowCode, deptId, maxDepth = 2) {
    return httpService.get(
      `/tools/checkMissingFlow?flowCode=${flowCode}&deptId=${deptId}&maxDepth=${maxDepth}`
    );
  },

  createFlow(form) {
    return httpService.post("/tools/createFlow", form);
  },

  deleteStateToState(form) {
    return httpService.post("/tools/deleteStateToState", form);
  },

  addRoleToFlowToRequest(form) {
    return httpService.post("/tools/addRoleToFlowToRequest", form);
  },

  addRoleToFlowToApprove(form) {
    return httpService.post("/tools/addRoleToFlowToApprove", form);
  },

  addRoleToFlowToLd(form) {
    return httpService.post("/tools/addRoleToFlowToLd", form);
  },

  getListStatesByFlowCodeAndDeptId(flowCode, deptId) {
    return httpService.get(
      `/tools/getListStatesByFlowCodeAndDeptId?flowCode=${flowCode}&deptId=${deptId}`
    );
  },

  getListStateToStateByFlowCodeAndDeptId(flowCode, deptId) {
    return httpService.get(
      `/tools/getListStateToStateByFlowCodeAndDeptId?flowCode=${flowCode}&deptId=${deptId}`
    );
  },

  getStateToStates(flowCode, deptId) {
    return httpService.get(
      `/tools/getStateToStates?flowCode=${flowCode}&deptId=${deptId}`
    );
  },

  getFlow(flowCode, deptId) {
    return httpService.get(
      `/tools/getFlow?flowCode=${flowCode}&deptId=${deptId}`
    );
  },

  getRoles() {
    return httpService.get(`/role`);
  },

  getDepartmentsByParentId(deptId) {
    return httpService.get(`/tools/getDepartmentsByParentId?deptId=${deptId}`);
  },

  exportVemaybay(form) {
    return httpService.postFile(`/vemaybay/export`, form);
  },
  getPositions() {
    return httpService.get(`/vemaybay/getPositions`);
  },
  getAirports() {
    return httpService.get(`/vemaybay/getAirports`);
  },
  getDepartments() {
    return httpService.get(`/vemaybay/getDepartments`);
  },

  // KHACH SAN
  getLocations() {
    return httpService.get(`/khachsan/getLocations`);
  },
  getHotels(locationid) {
    return httpService.get(`/khachsan/getHotels/${locationid}`);
  },
  createKhachsan(form) {
    return httpService.post("/khachsan/create", form);
  },
  viewDetailKhachsan(caseMasterId) {
    return httpService.get(`/khachsan/detail/${caseMasterId}`);
  },
  approveKhachsan(form) {
    return httpService.post(`/khachsan/approve`, form);
  },
  updateKhachsan(form) {
    return httpService.post(`/khachsan/update`, form);
  },
  cancelKhachsan(form) {
    return httpService.post(`/khachsan/cancel`, form);
  },
  exportKhachsan(caseMasterId) {
    return httpService.getFile(`/khachsan/export/${caseMasterId}`);
  },
  getListLD(deptCode) {
    return httpService.get(`/luongVb/getListLD?deptCode=${deptCode}`);
  },
  registerLuongVb(form) {
    return httpService.post("/luongVb/create", form);
  },
  getListLuongVanBan(form, pageable) {
    let params = utils.merge(pageable);
    return httpService.post("/luongVb/getListLuongVanBan", form, {
      params: params
    });
  },
  getDetailSteps(caseMasterId) {
    return httpService.get(
      `/luongVb/getDetailSteps?caseMasterId=${caseMasterId}`
    );
  },
  getDetailReturn(caseMasterId) {
    return httpService.get(
      `/luongVb/getDetailReturn?caseMasterId=${caseMasterId}`
    );
  },
  trinhVanBan(form) {
    return httpService.post("/luongVb/trinhVanBan", form);
  },
  traVanBan(form) {
    return httpService.post("/luongVb/traVanBan", form);
  },
  nhanVanBan(form) {
    return httpService.post("/luongVb/nhanVanBan", form);
  },
  donViNhanVanBan(form) {
    return httpService.post("/luongVb/donViNhanVanBan", form);
  },
  donViBaoCao(form) {
    return httpService.post("/luongVb/donViBaoCao", form);
  },
  huyVanBan(form) {
    return httpService.post("/luongVb/huyVanBan", form);
  },
  getDVTTByDeptCode(deptCode) {
    return httpService.get(`/luongVb/getDVTTByDeptCode?deptCode=${deptCode}`);
  },
  traVanBanDonVi(form) {
    return httpService.post("/luongVb/traVanBanDonVi", form);
  },
  traVanBanLanhDao(form) {
    return httpService.post("/luongVb/traVanBanLanhDao", form);
  },
  exportLuongVb(form) {
    return httpService.postFile(`/luongVb/exportLuongVb`, form);
  },
  approveCalendarByWeek(form) {
    return httpService.post(`/lichtuan/approveCalendarByWeek`, form);
  },
  getListHcCalendarByWeek(startDate, endDate, pageable) {
    return httpService.get(`/lichtuan/getListHcCalendarByWeek?startTime=${startDate}&endTime=${endDate}
    &size=${pageable.size}&page=${pageable.page}&sort=${pageable.sort}`);
  },

  //quy trình sửa chữa nhỏ:start

  registerSCNRequest(form) {
    return httpService.post("/suachuanhorequest/create", form);
  },
  updateSCNRequest(form) {
    return httpService.post("/suachuanhorequest/update", form);
  },

  findByHcCaseMaster(hcCaseMasterId) {
    let params = {hcCaseMasterId: hcCaseMasterId};
    return httpService.get("/hcCaseScn/findByHcCaseMaster", {
      params: params
    });
  },

  // approveSCN(form) {
  //   return httpService.post("/suachuanhorequest/approve", form);
  // },

  rejectSCN(form) {
    return httpService.post("/suachuanhorequest/approve", form);
  },

  findSCNById(id) {
    return httpService.get(`/hcCaseScn/${id}`);
  }
  //quy trình sửa chữa nhỏ:end
};

export default hanhchinhService;



// WEBPACK FOOTER //
// ./src/services/hanhchinhService.js